
import type { ChartVariant } from './types/internal/pie-chart.js';
import type {
  LabelTypeOptions,
  ThresholdType,
} from './types/pie-chart.config.js';
import type { TruncationMode } from '../../typography/text-ellipsis/TextEllipsis.js';
import { SCALE_FALLBACK_COLOR } from '../core/constants.js';
import { MappedObject } from '../core/types/helpers/mapped-object.js';

export const DONUT_CHART_DISPLAY_NAME = 'DonutChart';
export const PIE_CHART_DISPLAY_NAME = 'PieChart';

export const CHART_VARIANT = Object.freeze<MappedObject<ChartVariant>>({
  Donut: 'donut',
  Pie: 'pie',
});

export const THRESHOLD_TYPE_OPTION = Object.freeze<MappedObject<ThresholdType>>(
  {
    Absolute: 'absolute',
    NumberOfSlices: 'number-of-slices',
    Relative: 'relative',
  },
);

export const TRUNCATION_MODE = Object.freeze<MappedObject<TruncationMode>>({
  End: 'end',
  Middle: 'middle',
  Start: 'start',
});

export const LABEL_TYPE_OPTION = Object.freeze<MappedObject<LabelTypeOptions>>({
  Absolute: 'absolute',
  Relative: 'relative',
});

export const DEFAULT_SCALE_FALLBACK_COLOR = SCALE_FALLBACK_COLOR;

export const DONUT_CHART_ARIA_LABEL = 'Donut Chart';
export const PIE_CHART_ARIA_LABEL = 'Pie Chart';
export const PAD_ANGLE = 0.01;
